
namespace SorAraBul.Administration {

    @Serenity.Decorators.registerClass()
    export class UserCreditLogGrid extends Serenity.EntityGrid<UserCreditLogRow, any> {
        protected getColumnsKey() { return UserCreditLogColumns.columnsKey; }
        protected getDialogType() { return null; }
        protected getIdProperty() { return UserCreditLogRow.idProperty; }
        protected getInsertPermission() { return UserCreditLogRow.insertPermission; }
        protected getLocalTextPrefix() { return UserCreditLogRow.localTextPrefix; }
        protected getService() { return UserCreditLogService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

        //    this.refresh();      
        }

        //refresh() {
        //    super.refresh();

        //    SorAraBul.Common.Functions.updateCreditInfo(this.element);
        //}

        protected onViewSubmit() {
            const result = super.onViewSubmit();

            if (result) {
                SorAraBul.Common.Functions.addAndUpdateCreditInfo(this.element);
            }

            return result;
        }

        protected getButtons(): Serenity.ToolButton[] {

            // call base method to get list of buttons
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                grid: this,
                service: UserCreditLogService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;
        }
    }
}